"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function executeRollupRule(childActions, requiredCondition, childFormula, scaledScore) {
    const quantifier = childFormula.quantifier;
    switch (quantifier) {
        case 'all':
            if (childActions.every(item => item === requiredCondition)) {
                return true;
            }
            return false;
        // need to be changed for Incomplete ... Incomplete can be some complete or some Incomplete
        case 'any': {
            if (requiredCondition === 'inComplete' || requiredCondition === 'fail') {
                if (requiredCondition === 'inComplete' &&
                    (childActions.some(item => item === requiredCondition) || childActions.some(item => item === 'complete'))) {
                    return true;
                }
                if (requiredCondition === 'fail' && !childActions.some(item => item === 'na')) {
                    // if all section or assignment grades are received than only return fail.
                    return true;
                }
            }
            else if (childActions.some(item => item === requiredCondition)) {
                return true;
            }
            return false;
        }
        case 'atleast': {
            const value = childFormula.value;
            if (requiredCondition === 'minScaledScore') {
                return scaledScore !== 0 && scaledScore >= value;
            }
            if (childActions.length === 0)
                return false;
            const filteredActions = childActions.filter(item => item === requiredCondition);
            if (filteredActions.length / childActions.length >= value) {
                return true;
            }
            return false;
        }
        case 'atmost': {
            const value = childFormula.value;
            if (requiredCondition === 'minScaledScore') {
                return scaledScore !== 0 && scaledScore < value;
            }
            if (childActions.length === 0)
                return false;
            const filteredActions = childActions.filter(item => item === requiredCondition);
            if (filteredActions.length / childActions.length < value) {
                return true;
            }
            return false;
        }
        default:
            console.info('Invalid quantifier found in childFormula =' + childFormula);
            return false;
    }
}
exports.executeRollupRule = executeRollupRule;
//# sourceMappingURL=executeRollupRule.js.map